import { useMemo } from 'react';
import { IAutomationObject } from '../../types';
import { AutomationObjectsFlexGridView } from '../Grid/AutomationObjectsFlexGridView';
import { StyledDivider } from 'baseui/divider';
import { useStyletron } from 'baseui';
import { LabelMedium } from 'baseui/typography';
import useIsMobile from '../../../hooks/useIsMobile/useIsMobile';

const FilteredAppsView = (props: {
    apps: IAutomationObject[],
    header?: any,
    filter?: (app: IAutomationObject) => boolean,
    sort?: (a: any, b: any) => number
}) => {
    const { apps, filter, sort, header } = props;

    const isMobile = useIsMobile();
    const [css, theme] = useStyletron();
    const filterdItems = useMemo(() => {
        const filtered = filter ? apps?.filter((a) => filter(a) ?? false) : apps;
        const sorted = sort ? filtered?.sort(sort) : filtered;
        return sorted;
    }, [apps])

    if (filterdItems.length === 0)
        return (<></>);

    return (
        <div className={css({ width: '100%' })}>
            {header && <LabelMedium className={css({marginBottom: theme.sizing.scale300})} >{header}</LabelMedium>}
            <div>
                <AutomationObjectsFlexGridView noSort={props.sort !== undefined} items={filterdItems ?? []}></AutomationObjectsFlexGridView>
            </div>

            {!isMobile && <StyledDivider $size='cell'></StyledDivider>}
        </div>
    )
}

export default FilteredAppsView

export interface ISchemaSortDictionary {
    [index: string]: number;
}

export const sortBySchema = (a: IAutomationObject, b: IAutomationObject, sortDict: ISchemaSortDictionary): number => {
    const prioA = sortDict[a.schema]
    const prioB = sortDict[b.schema]
    if (prioB > prioA)
        return -1;
    if (prioB < prioA)
        return 1;
    
    return 0;
}

